<template>
    <div 
    class="inline-flex items-center justify-center text-xs font-bold px-2 py-0.5 rounded-2xl"
    :class="`bg-${color}-100 text-${color}-600`">
        {{ text }}
    </div>
    <div class="sr-only text-red-600"></div>
    <div class="sr-only text-violet-600"></div>
    <div class="sr-only text-blue-600"></div>
    <div class="sr-only text-yellow-600"></div>
    <div class="sr-only text-green-600"></div>
</template>

<script setup lang="ts">
defineProps({
    text: {
        type: String,
        default: null,
    },
    color: {
        type: String, // blue
        default: null,
    }
});
</script>